import { Component, ElementRef, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RemittanceService } from 'app/modules/remittance/services/remittance.service';
import { ToastrService } from 'ngx-toastr';
import { AddBankAccountRequest } from 'app/modules/bank-account/models/bank-account.model';
import { BankAccountService } from 'app/modules/bank-account/services/bank-account.service';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { Constants } from 'app/shared/constant/constants';
import { CardService } from 'app/modules/card/services/card.service';


import moment from 'moment';
import { UpdatePaymentDetailsRequestModel } from 'app/modules/order/models/order.model';
import { OrderService } from 'app/modules/order/services/order.service';
import { CryptoUtils } from 'app/shared/utility/crypto.utils';

@Component({
  selector: 'buy-lounge',
  templateUrl: './buy-lounge-access.component.html',
  styleUrls: ['./buy-lounge-access.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BuyLoungeComponent implements OnInit {
  public showLoader: boolean = false;
  firstName: string;
  lastName: string;
  email: string;
  mobileNo: string;
  address: string;
  state: string;
  city: string;
  simType: string;
  airTicket: string;
  visa: string;
  panCard: string;
  isChecked: boolean = false;
  isFormSubmitted: boolean = false;
  public showAddBankForm: boolean = false;
  public bankAccountList: any;

  @ViewChild('eSIMCardModal') eSIMCardModal: any;
  public addBankAccountRequest = new AddBankAccountRequest();
  public modalReference: any;
  public consumerId: any;
  public bankRelationshipList = Constants.payerList;
  public bankAccountId: any;
  public bankDropdownItemList: any;
  public selectedLounge: any;
  public paymentMode;
  public orderId;
  public cryptoUtils: CryptoUtils = new CryptoUtils();
  public isRetryPayment = false;

  public updatePaymentDetailsRequestModel = new UpdatePaymentDetailsRequestModel();

  public NBPaymentHtml: string = "";
  public NBPaymentInProcees: boolean = false;


  constructor(
    public router: Router,
    private modalService: NgbModal,
    public remittanceService: RemittanceService,
    public toast: ToastrService,
    public bankAccountService: BankAccountService,
    private cardService: CardService,
    public orderService: OrderService,
    private location: Location


  ) { }

  ngOnInit() {
    this.consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);

    let prevPage = sessionStorage.getItem(ConstantsKey.PREV_PAGE_URL);

    let isLoungeProcess = false;
    window.addEventListener('pageshow', (event) => {
      console.log("================================================================================= ESIM PAGE");
      let orderProcessStatus = localStorage.getItem(ConstantsKey.IS_LOUNGE_ORDER_DONE);
      if (orderProcessStatus && orderProcessStatus == "IN_PROCESS") {
        //window.location.reload(); //clean and reliable
        let orderData = localStorage.getItem(ConstantsKey.CURRENT_ORDER_TYPE);
        orderData = JSON.parse(orderData);
        let loungeOrderId = orderData["ORDER_ID"];
        localStorage.removeItem(ConstantsKey.IS_LOUNGE_ORDER_DONE);
        this.router.navigate(["/add-on/order-details/lounge/", loungeOrderId]);
        isLoungeProcess = true;
      }
    });

    if (isLoungeProcess == false) {
      if (prevPage.includes("/add-on/order-details/lounge/")) {
        let retryPayOrderData = JSON.parse(sessionStorage.getItem(ConstantsKey.ADD_ON_RETRY_PAY_ORDER));
        this.orderId = retryPayOrderData.orderId;
        this.selectedLounge = retryPayOrderData.orderData;
        this.isRetryPayment = true;
      } else {
        let localLoungeData = sessionStorage.getItem(ConstantsKey.SELECTED_LOUNGE);
        if (localLoungeData) {
          this.selectedLounge = JSON.parse(localLoungeData);
        }
      }

      this.getProfileList();
      this.getBankList();
      this.getBankAccountList();
    }


  }


  getProfileList() {

  }



  proceedToNextPage(pageUrl) {
    this.router.navigate([pageUrl]);
  }

  letterOnly(event: KeyboardEvent) {
    var charCode = event.keyCode;
    if (((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8) || charCode == 32)
      return true;
    else return false;
  }

  onSubmit(form: any) {
    if (form.valid) {
      this.isFormSubmitted = true;
    } else {
      form.form.markAllAsTouched();
    }
  }

  markAllFieldsAsTouched(form: NgForm) {
    Object.values(form.controls).forEach(control => {
      control.markAsTouched();
    });
  }
  onCheckboxChange() {
    console.log('Checkbox state:', this.isChecked);
  }
  openModal() {
    this.modalService.open(this.eSIMCardModal, { centered: true, size: 'md' });
  }



  closeModalAndNavigate() {
    this.modalService.dismissAll();
    // Add navigation logic here, e.g., using Angular Router
    // this.router.navigate(['/some-route']);
  }

  getBankAccountList() {
    this.remittanceService.getBankAccountList().subscribe(resp => {
      this.bankAccountList = resp.body;
    });
  }

  addBankAccount(data) {
    if (data === true) {
      this.showLoader = true;
      if (this.addBankAccountRequest.number === this.addBankAccountRequest.confirmAccNo) {
        this.addBankAccountRequest.consumerId = this.consumerId;
        this.addBankAccountRequest.default = true;
        this.addBankAccountRequest.type = 'SAVINGS';
        this.addBankAccountRequest.isDefault = true;
        console.log(JSON.stringify(this.addBankAccountRequest));

        this.bankAccountService.addMyBankAccount(this.addBankAccountRequest).subscribe(resp => {
          this.showLoader = false;
          this.toast.success("Bank account added successfully", "Success !!");
          this.modalReference.close();

          this.getBankAccountList();
        }, error => {
          this.showLoader = false;
          console.log(error);
          this.toast.error(error.error.message);
        });
      } else {
        this.showLoader = false;
        this.toast.error("Account no and confirm account no. must be same");
      }

    }
  }

  openModalForAddBankAccount(addBankModal) {
    this.addBankAccountRequest.branch = null;
    this.modalReference = this.modalService.open(addBankModal, { size: 'lg', centered: true });

  }

  alphaNumberOnly(e) {  // Accept only alpha numerics, not special characters 
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }
    e.preventDefault();
    return false;
  }

  getSelectedBankAccountID(id) {
    this.bankAccountId = id;
  }

  getBankList() {
    var singleObject;
    var localBankDropdownItemList;
    this.bankAccountService.getPaymentModes().subscribe(res => {

      localBankDropdownItemList = res.body;
      for (let i = 0; i < localBankDropdownItemList.length; i++) {
        singleObject = localBankDropdownItemList[i];
        if (singleObject.categoryName == "Net Banking") {
          this.bankDropdownItemList = singleObject.paymentModeCategories;
        }
      }

    });
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  goToLoungeListPage() {
    this.location.back();
  }

  validateProceed() {

    if (!this.paymentMode) {
      this.toast.error("Please select payment mehtod");
      return false;
    }
    if (this.paymentMode == 'NB' && !this.bankAccountId) {
      this.toast.error("Please select bank account");
      return false;
    }
    return true;
  }

  placeLoungeAccessOrder() {

    let outletId = this.selectedLounge["outletId"];
    if (this.validateProceed()) {
      this.showLoader = true;

      if (this.isRetryPayment) {
        let orderType = { "ORDER_TYPE": "LOUNGE", "ORDER_ID": this.orderId };
        localStorage.setItem(ConstantsKey.CURRENT_ORDER_TYPE, JSON.stringify(orderType));

        /* if(this.paymentMode == "NB") {
          this.callPaymentGateway();
        } else if(this.paymentMode == "UPI") { */
        this.getPayULink();
        /* } */
      } else {
        this.cardService.placeLoungeAccessOrder(outletId).subscribe(resp => {

          let orderData = resp.body;
          this.orderId = orderData["id"];

          let orderType = { "ORDER_TYPE": "LOUNGE", "ORDER_ID": this.orderId };
          localStorage.setItem(ConstantsKey.CURRENT_ORDER_TYPE, JSON.stringify(orderType));

          /* if(this.paymentMode == "NB") {
            this.callPaymentGateway();
          } else { */
          this.getPayULink();
          /* } */
        }, err => {
          this.showLoader = true;
          this.toast.error(err.error.message);
        });
      }


    }






  }

  addPaymentDetails() {
    this.updatePaymentDetailsRequestModel.orderId = this.orderId;
    this.updatePaymentDetailsRequestModel.referenceNumber = '';
    this.updatePaymentDetailsRequestModel.manualPaymentType = 'NEFT';
    this.updatePaymentDetailsRequestModel.amount = this.selectedLounge["salePrice"];
    this.updatePaymentDetailsRequestModel.paymentDate = moment(new Date()).format('YYYY-MM-DD');
    this.updatePaymentDetailsRequestModel.consumerId = this.consumerId;

    this.orderService.updatePaymentDetails(this.updatePaymentDetailsRequestModel).subscribe(resp => {
      let paymentDetails = resp.body;

    }, err => {

      this.toast.error(err.error.message);
    });

  }


  getPayULink() {
    let selectedPaymentType = this.paymentMode;

    let requestObj = {
      'paymentType': selectedPaymentType,
      'orderId': this.orderId,
      'product': 'LOUNGE_ACCESS',
      'deviceType': 'WEB',
      'orderType': 'LOUNGE_ACCESS'
    };

    if (this.paymentMode == "NB") {
      requestObj['bankId'] = this.bankAccountId;
    }

    this.orderService.getPayUOtherLink(requestObj).subscribe(resp => {
      this.showLoader = false;
      var respUPIPayLinkData = JSON.parse(JSON.stringify(resp.body));
      localStorage.setItem(ConstantsKey.IS_LOUNGE_ORDER_DONE, "IN_PROCESS");
      //window.location.href = respUPIPayLinkData.redirectionURL;

      if (respUPIPayLinkData.status == "SUCCESS") {
        // if(this.paymentMode == "NB") {
        //   this.NBPaymentHtml = respUPIPayLinkData.htmlCode;
        //   document.open();          
        //   document.write(this.NBPaymentHtml);
        //   document.close();
        // } else if(this.paymentMode == "UPI") {
        //   window.location.href = respUPIPayLinkData.redirectionURL;
        // }
        if (respUPIPayLinkData.redirectionURL) {
          window.location.href = respUPIPayLinkData.redirectionURL;
        } else {
          this.NBPaymentHtml = respUPIPayLinkData.htmlCode;
          document.open();
          document.write(this.NBPaymentHtml);
          document.close();
        }
      } else if (respUPIPayLinkData.status == "ERROR") {
        let errMsg: string = respUPIPayLinkData.errorDescription;
        if (errMsg.includes("not support PayU")) {
          this.callPaymentGateway();
        }
      }

    }, err => {
      // console.log("err callQuotation >", err);
      this.toast.error(err.error.message);
    });
  }

  callPaymentGateway() {
    this.cardService.callPaymentGatewayForLounge(this.orderId, this.bankAccountId).subscribe(respPaymentLink => {
      this.showLoader = false;

    }, err => {
      this.showLoader = false;
      if (err.status == 200) {
        var responsePaymentLinkBody = JSON.parse(this.cryptoUtils.resDecrypt(err.error.text));
        localStorage.setItem(ConstantsKey.IS_LOUNGE_ORDER_DONE, "IN_PROCESS");
        window.location.href = responsePaymentLinkBody.payment_link;
      } else {
        this.showLoader = false;
        // console.log("err callQuotation >", err);
        this.toast.error(err.error.message);
      }
    });
  }


}
